namespace TabAurous.OMS {
    export interface CategoryMasterForm {
        CategoryCode: Serenity.StringEditor;
        CategoryName: Serenity.StringEditor;
        ItemTypeId: Serenity.LookupEditor;
        Image: Serenity.ImageUploadEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsSizeApplicable: Serenity.BooleanEditor;
    }

    export class CategoryMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CategoryMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CategoryMasterForm.init)  {
                CategoryMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.ImageUploadEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(CategoryMasterForm, [
                    'CategoryCode', w0,
                    'CategoryName', w0,
                    'ItemTypeId', w1,
                    'Image', w2,
                    'IsDisabled', w3,
                    'IsSizeApplicable', w3
                ]);
            }
        }
    }
}
